import { create } from "zustand";

const LoaderState = create((set) => ({
  status: false,
  message: "Please wait....",
  setLoaderStatus: (status) => {
    set((prev) => ({ ...prev, status: status }));
  },
  setLoaderMessage: (message) => {
    set((prev) => ({ ...prev, message: message }));
  },
}));

export default LoaderState;
